module.exports = __webpack_public_path__ + "static/img/pc.765157b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/pc.png
// module id = nfxX
// module chunks = 1